import { useEffect, useState } from "react";

// Tracks browser connectivity. `justReconnected` briefly flips true when a
// dropped connection comes back, so the UI can reassure the user.
export function useOnlineStatus() {
  const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine));
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    let timer;
    const goOnline = () => {
      setOnline(true);
      setJustReconnected(true);
      clearTimeout(timer);
      timer = setTimeout(() => setJustReconnected(false), 3000);
    };
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      clearTimeout(timer);
    };
  }, []);

  return { online, justReconnected };
}
